import * as React from 'react';

import { Badge } from 'components/badge/badge';

const setBadgesList = (list: string[], indexList: number[]) =>
  list.map((text, index) => (
    <React.Fragment key={`badge-${index}`}>
      <div className="badges__list-item">
        <Badge {...{ index: indexList[index] || index, text }} />
      </div>
    </React.Fragment>
  ));

type BadgesProps = {
  lists: string[][];
  indexList: number[][];
};

export const Badges = (props: BadgesProps) => {
  return (
    <section className="badges">
      {props.lists.map((list, key) => (
        <div className="badges__list" key={key}>
          {setBadgesList(list, props.indexList[key])}
        </div>
      ))}
    </section>
  );
};
